import ReactGA from 'react-ga';
import 'autotrack';

export const SetupAnalytics = () => {
    ReactGA.initialize('UA-157370548-1', {
        debug: false,
    });
    ReactGA.plugin.require('urlChangeTracker');
    ReactGA.plugin.require('eventTracker');
}